import { ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store';
import { generalFlowDataKey, GeneralFlowDataState, generalReducer } from '@store/flow-data/general';
import { couponFlowDataKey, CouponFlowDataState, couponReducer } from './flow-data/coupon';
import { localStorageSync } from 'ngrx-store-localstorage';
import { initFlowFlowDataKey, InitFlowFlowDataState, initFlowReducer } from './flow-data/init-flow';
import { quickQuoteFlowDataKey, QuickQuoteFlowDataState, quickQuoteReducer } from './flow-data/quick-quote';
import {
  ActivityRegistryEffects,
  activityRegistryKey,
  activityRegistryReducer,
  ActivityRegistryState,
} from './activity-registry/activity-registry';
import { runtimeFlowDataKey, RuntimeFlowDataState, runtimeReducer } from './flow-data/runtime';

// tslint:disable-next-line: no-any
const reducers: ActionReducerMap<any> = {
  [couponFlowDataKey]: couponReducer,
  [generalFlowDataKey]: generalReducer,
  [initFlowFlowDataKey]: initFlowReducer,
  [quickQuoteFlowDataKey]: quickQuoteReducer,
  [activityRegistryKey]: activityRegistryReducer,
  [runtimeFlowDataKey]: runtimeReducer,
};

// Meta-reducer to sync with localStorage
export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({
    storage: sessionStorage,
    keys: [couponFlowDataKey, generalFlowDataKey],
    rehydrate: true,
  })(reducer);
}

export const metaReducers: MetaReducer<any>[] = [localStorageSyncReducer];

const effects = [ActivityRegistryEffects];

export interface AppState {
  [couponFlowDataKey]: CouponFlowDataState;
  [generalFlowDataKey]: GeneralFlowDataState;
  [initFlowFlowDataKey]: InitFlowFlowDataState;
  [quickQuoteFlowDataKey]: QuickQuoteFlowDataState;
  [activityRegistryKey]: ActivityRegistryState;
  [runtimeFlowDataKey]: RuntimeFlowDataState;
}

export { reducers, effects };
